function handleScroll() {
  const floatingWidget = document.querySelector(".FloatingWidget");
  if (window.scrollY > window.innerHeight * 0.001 && floatingWidget) {
    floatingWidget.classList.add("FloatingWidget--isHiddenOnScroll");
  } else if (floatingWidget) {
    floatingWidget.classList.remove("FloatingWidget--isHiddenOnScroll");
  }
}

window.addEventListener("scroll", handleScroll);
document.addEventListener("DOMContentLoaded", handleScroll);

/* Price per Portion */
function updatePortionPrice() {
  const elements = document.querySelectorAll(".portion-price-data");
  elements.forEach(function (element) {
    const variantId = element.getAttribute("data-variant-id");
    const currentVariantId = window.currentVariantId;

    if (variantId == currentVariantId) {
      const portionPrice = element.getAttribute("data-variant-portion-price");
      document.querySelector(".portion-price__price b").innerHTML =
        portionPrice;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const variantInput = document.querySelector(
    '.shopify-product-form input[name="id"]'
  );
  if (variantInput) {
    window.currentVariantId = variantInput.value;
    updatePortionPrice();
  }

  document.addEventListener("variant:change", function (event) {
    window.currentVariantId = event.detail.variant.id;
    updatePortionPrice();
  });
});

// Cart Messaging
function updateCartMessages(message) {
  const messageWrap = document.querySelector(".cart-drawer__messages");
  const messageDiv = document.querySelector(".cart-drawer__messages .message");
  if (messageDiv) {
    messageWrap.style.display = "flex";
    messageDiv.textContent = message;
  }
}

document.addEventListener("cart:change", function (event) {
  if (event.detail && event.detail.baseEvent === "variant:add") {
    updateCartMessages("Produkt hinzugefügt");
  } else {
    updateCartMessages("Warenkorb aktualisiert");
  }
});

/* Accordion in Accordion */
document.querySelectorAll(".accordion-list__trigger").forEach((trigger) => {
  trigger.addEventListener("click", function () {
    const content = this.nextElementSibling;

    this.classList.toggle("is-open");

    if (content.classList.contains("open")) {
      content.style.maxHeight = 0;
      content.classList.remove("open");
    } else {
      content.classList.add("open");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});

/* Show Sticky ATC when main ATC is out of viewport */
var isOutOfViewport = function (element) {
  var bounding = element.getBoundingClientRect(),
    out = {};
  return (
    (out.top = bounding.top < 0),
    (out.left = bounding.left < 0),
    (out.bottom =
      bounding.bottom >
      (window.innerHeight || document.documentElement.clientHeight)),
    (out.right =
      bounding.right >
      (window.innerWidth || document.documentElement.clientWidth)),
    (out.any = out.top || out.left || out.bottom || out.right),
    (out.all = out.top && out.left && out.bottom && out.right),
    out
  );
};

let stickyButton = document.querySelector(".product-quick-add");
if (stickyButton) {
  window.addEventListener("scroll", function (event) {
    let mainButton = document.querySelector(
      ".product-info__buy-buttons .buy-buttons button"
    );

    let viewportWidth = window.innerWidth;

    let buttonOut = isOutOfViewport(mainButton);

    if (viewportWidth <= 999) {
      if (buttonOut.top || buttonOut.bottom) {
        stickyButton.classList.add("is-visible");
      } else {
        stickyButton.classList.remove("is-visible");
      }
    } else if (viewportWidth >= 1000) {
      if (buttonOut.top) {
        stickyButton.classList.add("is-visible");
      } else {
        stickyButton.classList.remove("is-visible");
      }
    }
  });
}
/* Product Images AB-Testing */
// window.updateImagesWithTestImage = function () {
//     var images = document.querySelectorAll('img[data-test-image]');

//     images.forEach(function (image) {
//         var originalSrc = image.getAttribute('src').split('?')[0];

//         var newSrc = image.getAttribute('data-test-image');

//         if (newSrc) {
//             if (image.src.split('?')[0] === originalSrc) {
//                 image.src = newSrc;
//             }

//             var srcset = image.getAttribute('srcset');
//             if (srcset) {
//                 var newSrcset = srcset.replace(new RegExp(originalSrc, 'g'), newSrc);
//                 image.setAttribute('srcset', newSrcset);
//             }
//         }
//     });
// };

// Helper for Product Images AB-Testing
// document.addEventListener('DOMContentLoaded', function () {
//     if (typeof window.updateImagesWithTestImage === 'function') {
//         window.updateImagesWithTestImage();
//     }
// });

/* Discount Code Elements */
(function () {
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function setCookie(name, value, days = 7) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/;`;
  }

  function updateAllContainers(allContainers, discountCode) {
    allContainers.forEach((container) => {
      const introText = container.querySelector(".intro-text");
      const discountText = container.querySelector(".discount-text");

      if (!discountText) {
        return;
      }

      const containerDiscountCode =
        discountText.getAttribute("data-discount-code");
      const successText = container.querySelector(".success-text");

      if (containerDiscountCode === discountCode) {
        if (introText) introText.style.display = "none";
        if (discountText) discountText.style.display = "none";
        if (successText) successText.style.display = "inline";
      } else {
        if (introText) introText.style.display = "inline";
        if (discountText) discountText.style.display = "inline";
        if (successText) successText.style.display = "none";
      }
    });
  }

  function setRedeemedClass(announcementBar, delay = 0) {
    if (announcementBar) {
      setTimeout(() => {
        announcementBar.classList.add("redeemed");
      }, delay);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const announcementBar = document.querySelector(
      ".shopify-section--announcement-bar"
    );
    const productInfoDiscountCode = document.querySelector(
      ".product-info__discount-code"
    );
    const allContainers = [announcementBar, productInfoDiscountCode].filter(
      Boolean
    ); // Nur existierende Elemente

    // Standardmäßig alle Container aktualisieren
    const initialDiscountCode = getCookie("discount_code") || null;
    updateAllContainers(allContainers, initialDiscountCode);

    // Setze die Klasse 'redeemed' für announcementBar, wenn ein Code existiert
    if (initialDiscountCode && announcementBar) {
      setRedeemedClass(announcementBar);
    }

    allContainers.forEach((container) => {
      container.querySelectorAll("[data-discount-code]").forEach((element) => {
        element.addEventListener("click", function () {
          const discountCode = this.getAttribute("data-discount-code");

          setCookie("discount_code", discountCode);

          updateAllContainers(allContainers, discountCode);

          // Verzögert die Klasse 'redeemed' nur für announcementBar setzen
          if (announcementBar) {
            setRedeemedClass(announcementBar, 1000);
          }

          fetch(`/discount/${discountCode}`)
            .then(function () {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            })
            .catch(function (error) {
              console.error("Error:", error);
            });
        });
      });
    });
  });
})();

// Quizify Add to Cart Event
window.addEventListener("quizifyAddToCart", async function () {
  document.dispatchEvent(new CustomEvent("cart:refresh"));

  try {
    const cartResponse = await fetch("/cart.js");
    const cartData = await cartResponse.json();
    console.log("Cart data:", cartData);

    const cartCounts = document.querySelectorAll("cart-count");
    cartCounts.forEach((element) => {
      element.itemCount = cartData.item_count;
    });
  } catch (error) {
    console.error("Failed to fetch cart:", error);
  }

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.show();
  }
});
